/* K9 cart drawer text in the design direction (Drop 3, 20 Oct 2026): ₹ in place of "Rs.", no ".00" on the subtotal, and
   no leading emoji on the drawer's two notes. Rebuy's own callback strips decimals inside .rebuy-money but leaves the
   currency and the subtotal; this rewrites only text that still needs it, so the two never undo each other. Only ".00"
   comes off the subtotal, so a total with paise is never shown rounded. */
(function () {
  'use strict';
  var LEAD = /^\s*(?:\p{Extended_Pictographic}|\p{Emoji_Modifier}|\uFE0F|\u200D)+\s*/u;

  function textNodes(el, fn) {
    el.childNodes.forEach(function (n) {
      if (n.nodeType === 3) fn(n);
    });
  }

  function fix(root) {
    root.querySelectorAll('.rebuy-money span, .rebuy-money, .rebuy-cart__flyout-subtotal-amount span').forEach(function (el) {
      textNodes(el, function (n) {
        var v = n.textContent.replace(/Rs\.\s?/, '\u20B9').replace(/(\d)\.00\b/, '$1');
        if (v !== n.textContent) n.textContent = v;
      });
    });
    root.querySelectorAll('.message.splide__slide').forEach(function (el) {
      textNodes(el, function (n) {
        var v = n.textContent.replace(LEAD, '');
        if (v !== n.textContent) n.textContent = v;
      });
    });
  }

  function start() {
    var root = document.getElementById('rebuy-cart');
    if (!root) return false;
    fix(root);
    new MutationObserver(function () { fix(root); }).observe(root, { childList: true, subtree: true, characterData: true });
    return true;
  }

  if (!start()) {
    var tries = 0;
    var iv = setInterval(function () { if (start() || ++tries > 40) clearInterval(iv); }, 500);
  }
})();
